<template>

  <div>
    <creating
      v-if="creating"
      height="100%" />

    <div
      v-if="!creating"
      class="job-board-list">
      <JobAdvertiseBoardsItem
        v-for="(jobBoard, index) in jobBoards"
        :key="index"
        class="job-board"
        :jobBoard="jobBoard" />
    </div>
  </div>

</template>

<script>
import JobAdvertiseBoardsItem from './JobAdvertiseBoardsItem'

export default {
  name: 'JobAdvertise',
  components: {
    JobAdvertiseBoardsItem
  },
  data () {
    return {
      creating: true
    }
  },
  computed: {
    job () {
      return this.$store.getters.getJob
    },
    jobBoards () {
      return this.$store.getters.getJobBoards
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData () {
      Promise.all([
        this.$store.dispatch('selectJobBoards', {}),
        this.$store.dispatch('selectPostings', {
          job_id: this.job._id
        })
      ])
      .then(result => {
        this.creating = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.job-board-list{
  display: flex;
  flex-wrap: wrap;
  margin: -0.5em;
}
  .job-board-list > * {
    flex: 1 240px;
    margin: 0.5em;
    max-width: 240px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Job/JobAdvertise/JobAdvertiseBoards.vue